(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bou-quiz-producto"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bou-product-quiz')) {
    class BouProductQuiz extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.status = this.querySelector('[data-quiz-status]');
        this.progress = this.querySelector('[data-quiz-progress]');
        this.backButton = this.querySelector('[data-quiz-back]');
        this.choices = {};
        this.category = '';
        this.history = ['start'];

        this.addEventListener('click', (event) => {
          const choice = event.target.closest('[data-quiz-choice]');
          const back = event.target.closest('[data-quiz-back]');
          const restart = event.target.closest('[data-quiz-restart]');
          const add = event.target.closest('[data-add-result]');
          const storyTab = event.target.closest('[data-history-tab]');

          if (choice && this.contains(choice)) this.handleChoice(choice);
          if (back && this.contains(back)) this.goBack();
          if (restart && this.contains(restart)) this.restart();
          if (add && this.contains(add)) this.addToCart(add);
          if (storyTab && this.contains(storyTab)) this.showHistory(storyTab.dataset.historyTab);
        });
      }

      showHistory(id) {
        this.querySelectorAll('[data-history-tab]').forEach((tab) => {
          tab.setAttribute('aria-selected', String(tab.dataset.historyTab === id));
        });
        this.querySelectorAll('[data-history-panel]').forEach((panel) => {
          const active = panel.dataset.historyPanel === id;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      }

      parseScores(value) {
        const scores = {};
        if (!value) return scores;
        value.split(',').forEach((pair) => {
          const parts = pair.split(':');
          if (parts[0]) scores[parts[0]] = Number(parts[1] || 0);
        });
        return scores;
      }

      handleChoice(button) {
        const panel = button.closest('[data-panel]');
        const current = panel ? panel.dataset.panel : 'start';
        const next = button.dataset.next;
        if (!next) return;

        if (button.dataset.category) {
          this.category = button.dataset.category;
          this.choices = {};
          this.history = ['start'];
        } else {
          this.choices[current] = this.parseScores(button.dataset.scores);
        }

        if (next === 'result') this.renderResult();
        this.history.push(next);
        this.showPanel(next);
      }

      showPanel(id) {
        let target = null;
        this.panels.forEach((panel) => {
          const active = panel.dataset.panel === id;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
          if (active) target = panel;
        });

        if (!target) return;
        if (this.status) this.status.textContent = target.dataset.status || '';
        if (this.progress) this.progress.style.width = `${target.dataset.progress || 0}%`;
        if (this.backButton) this.backButton.hidden = id === 'start' || id === 'result';

        const heading = target.querySelector('.bou-quiz__question');
        window.requestAnimationFrame(() => {
          if (heading) heading.focus({ preventScroll: true });
          const rect = this.getBoundingClientRect();
          if (rect.top < -20) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      goBack() {
        if (this.history.length <= 1) return;
        this.history.pop();
        const previous = this.history[this.history.length - 1];

        if (previous === 'start') {
          this.category = '';
          this.choices = {};
        } else {
          delete this.choices[previous];
        }
        this.showPanel(previous);
      }

      restart() {
        this.choices = {};
        this.category = '';
        this.history = ['start'];
        this.querySelectorAll('[data-result-key]').forEach((card) => { card.hidden = true; });
        this.showPanel('start');
      }

      renderResult() {
        const priorities = this.category === 'wine'
          ? ['wine_carmenere', 'wine_blend_maipo', 'wine_cabernet', 'wine_blend_choapa', 'wine_late_harvest']
          : ['pisco_roble', 'pisco_blanco', 'pisco_especial', 'pisco_gran', 'pisco_pirquinero'];
        const totals = {};
        priorities.forEach((key) => { totals[key] = 0; });

        Object.values(this.choices).forEach((answer) => {
          Object.entries(answer).forEach(([key, value]) => {
            if (Object.prototype.hasOwnProperty.call(totals, key)) totals[key] += value;
          });
        });

        const cards = Array.from(this.querySelectorAll('[data-result-key]'));
        cards.forEach((card) => { card.hidden = true; });
        const available = priorities.filter((key) => {
          const card = cards.find((item) => item.dataset.resultKey === key);
          return card && card.dataset.configured === 'true';
        });
        const fallback = this.querySelector('[data-result-fallback]');
        if (fallback) fallback.hidden = true;

        if (!available.length) {
          if (fallback) fallback.hidden = false;
          return;
        }

        let winner = available[0];
        available.forEach((key) => {
          if (totals[key] > totals[winner]) winner = key;
        });
        const winningCard = cards.find((card) => card.dataset.resultKey === winner);
        if (winningCard) winningCard.hidden = false;
      }

      async addToCart(button) {
        const variantId = Number(button.dataset.variantId);
        const message = button.closest('[data-result-key]')?.querySelector('[data-cart-message]');
        if (!variantId || button.disabled) return;

        const originalText = button.textContent;
        button.disabled = true;
        button.textContent = 'Agregando…';
        if (message) message.textContent = '';

        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
          if (!response.ok) throw new Error('No se pudo agregar el producto');

          let cart = null;
          const cartResponse = await fetch(this.dataset.cartUrl, { credentials: 'same-origin' });
          if (cartResponse.ok) cart = await cartResponse.json();

          button.textContent = 'Agregado al carrito ✓';
          if (message) message.textContent = 'Tu botella ya está en el carrito.';
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
        } catch (error) {
          button.disabled = false;
          button.textContent = originalText;
          if (message) message.textContent = 'No pudimos agregarlo. Intenta nuevamente o abre el producto.';
        }
      }
    }

    customElements.define('bou-product-quiz', BouProductQuiz);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pack-builder-sugar-style"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class PBXPackBuilder {
      constructor(root) {
        if (!root || root.dataset.pbxInitialized === 'true') return;
        root.dataset.pbxInitialized = 'true';

        this.root = root;
        this.cards = [...root.querySelectorAll('[data-pbx-card]')];
        this.currency = root.dataset.currency || 'USD';
        this.minBuy = Math.max(1, Number(root.dataset.minBuy || 1));
        this.discountMode = root.dataset.discountMode || 'automatic';
        this.afterAdd = root.dataset.afterAdd || 'cart';
        this.resetAfterAdd = root.dataset.resetAfterAdd === 'true';
        this.packName = root.dataset.packName || 'Pack personalizado';
        this.button = root.querySelector('[data-pbx-buy]');
        this.message = root.querySelector('[data-pbx-message]');
        this.status = root.querySelector('[data-pbx-status]');
        this.progressFill = root.querySelector('[data-pbx-progress-fill]');
        this.markers = [...root.querySelectorAll('[data-pbx-marker]')];

        this.tiers = [1, 2, 3]
          .map((index) => ({
            qty: Number(root.dataset[`tier${index}Qty`] || 0),
            discount: Number(root.dataset[`tier${index}Discount`] || 0),
            code: root.dataset[`tier${index}Code`] || ''
          }))
          .filter((tier) => tier.qty > 0)
          .sort((a, b) => a.qty - b.qty);

        this.maxTierQty = Math.max(1, ...this.tiers.map((tier) => tier.qty));
        this.bind();
        this.positionMarkers();
        this.update();
      }

      bind() {
        this.root.addEventListener('click', (event) => {
          const plus = event.target.closest('[data-pbx-plus]');
          const minus = event.target.closest('[data-pbx-minus]');

          if (plus) {
            this.changeQuantity(plus.closest('[data-pbx-card]'), 1);
          }

          if (minus) {
            this.changeQuantity(minus.closest('[data-pbx-card]'), -1);
          }
        });

        this.root.addEventListener('change', (event) => {
          const select = event.target.closest('[data-pbx-variant]');
          if (!select) return;

          const card = select.closest('[data-pbx-card]');
          const option = select.options[select.selectedIndex];
          card.dataset.variantId = select.value;
          card.dataset.price = option.dataset.price || '0';

          const priceNode = card.querySelector('[data-pbx-card-price]');
          if (priceNode) priceNode.textContent = this.formatMoney(Number(card.dataset.price));
          this.update();
        });

        if (this.button) {
          this.button.addEventListener('click', () => this.addPack());
        }
      }

      positionMarkers() {
        this.markers.forEach((marker) => {
          const qty = Number(marker.dataset.qty || 0);
          const percent = Math.min(100, Math.max(0, (qty / this.maxTierQty) * 100));
          marker.style.left = `${percent}%`;
        });
      }

      changeQuantity(card, delta) {
        if (!card || card.dataset.available !== 'true') return;

        const current = Number(card.dataset.qty || 0);
        const next = Math.max(0, Math.min(99, current + delta));
        card.dataset.qty = String(next);

        const qtyNode = card.querySelector('[data-pbx-qty]');
        if (qtyNode) qtyNode.textContent = String(next);

        card.classList.toggle('is-selected', next > 0);
        this.update();
      }

      getState() {
        const itemsByVariant = new Map();
        let totalQty = 0;
        let subtotal = 0;

        this.cards.forEach((card) => {
          const qty = Number(card.dataset.qty || 0);
          if (qty <= 0) return;

          const variantId = Number(card.dataset.variantId || 0);
          const price = Number(card.dataset.price || 0);
          if (!variantId) return;

          totalQty += qty;
          subtotal += price * qty;
          itemsByVariant.set(variantId, (itemsByVariant.get(variantId) || 0) + qty);
        });

        const items = [...itemsByVariant.entries()].map(([id, quantity]) => ({ id, quantity }));
        return { totalQty, subtotal, items };
      }

      getCurrentTier(totalQty) {
        return this.tiers.reduce((current, tier) => totalQty >= tier.qty ? tier : current, null);
      }

      getNextTier(totalQty) {
        return this.tiers.find((tier) => totalQty < tier.qty) || null;
      }

      formatMoney(cents) {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'es-CL', {
            style: 'currency',
            currency: this.currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format((Number(cents) || 0) / 100);
        } catch (error) {
          return `${Math.round((Number(cents) || 0) / 100)} ${this.currency}`;
        }
      }

      update() {
        const state = this.getState();
        const currentTier = this.getCurrentTier(state.totalQty);
        const nextTier = this.getNextTier(state.totalQty);
        const discount = currentTier ? currentTier.discount : 0;
        const total = Math.round(state.subtotal * (1 - discount / 100));

        const progress = Math.min(100, (state.totalQty / this.maxTierQty) * 100);
        if (this.progressFill) this.progressFill.style.width = `${progress}%`;

        this.markers.forEach((marker) => {
          const qty = Number(marker.dataset.qty || 0);
          marker.classList.toggle('is-active', state.totalQty >= qty);
        });

        if (this.message) {
          if (state.totalQty === 0) {
            this.message.textContent = 'Agrega productos para comenzar.';
          } else if (nextTier && currentTier) {
            const missing = nextTier.qty - state.totalQty;
            this.message.textContent = `¡-${currentTier.discount}% desbloqueado! Suma ${missing} ${missing === 1 ? 'unidad' : 'unidades'} para llegar al -${nextTier.discount}%.`;
          } else if (nextTier) {
            const missing = nextTier.qty - state.totalQty;
            this.message.textContent = `Suma ${missing} ${missing === 1 ? 'unidad' : 'unidades'} para desbloquear el -${nextTier.discount}%.`;
          } else if (currentTier) {
            this.message.textContent = `¡Máximo descuento desbloqueado: -${currentTier.discount}%!`;
          }
        }

        const subtotalNode = this.root.querySelector('[data-pbx-subtotal]');
        const discountLabel = this.root.querySelector('[data-pbx-discount-label]');
        const discountValue = this.root.querySelector('[data-pbx-discount-value]');
        const totalNode = this.root.querySelector('[data-pbx-total]');

        if (subtotalNode) subtotalNode.textContent = this.formatMoney(state.subtotal);
        if (discountLabel) discountLabel.textContent = discount > 0 ? `Descuento -${discount}%` : 'Descuento';
        if (discountValue) discountValue.textContent = discount > 0 ? `-${this.formatMoney(state.subtotal - total)}` : '—';
        if (totalNode) totalNode.textContent = this.formatMoney(total);

        if (this.button) {
          this.button.disabled = state.totalQty < this.minBuy;
        }
      }

      setStatus(message, isError = false) {
        if (!this.status) return;
        this.status.textContent = message || '';
        this.status.classList.toggle('is-error', Boolean(isError));
      }

      async addPack() {
        const state = this.getState();
        if (state.totalQty < this.minBuy || !state.items.length || !this.button) return;

        const currentTier = this.getCurrentTier(state.totalQty);

        if (this.discountMode === 'code' && currentTier && currentTier.discount > 0 && !currentTier.code) {
          this.setStatus(`Falta configurar el código para el nivel -${currentTier.discount}%.`, true);
          return;
        }

        const originalText = this.button.textContent;
        this.button.disabled = true;
        this.button.textContent = 'Agregando…';
        this.setStatus('');

        const packInstance = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
        const items = state.items.map((item) => ({
          ...item,
          properties: {
            '_Pack': this.packName,
            '_Pack_ID': packInstance
          }
        }));

        try {
          const addResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items,
              sections: 'cart-icon-bubble',
              sections_url: window.location.pathname
            })
          });

          const addData = await addResponse.json();
          if (!addResponse.ok) {
            throw new Error(addData.description || addData.message || 'No fue posible agregar el pack.');
          }

          if (this.discountMode === 'code' && currentTier?.code) {
            const discountResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ discount: currentTier.code })
            });

            const discountData = await discountResponse.json();
            if (!discountResponse.ok) {
              throw new Error(discountData.description || 'El pack se agregó, pero no se pudo aplicar el descuento.');
            }
          }

          if (addData.sections?.['cart-icon-bubble']) {
            const currentBubble = document.querySelector('#shopify-section-cart-icon-bubble');
            if (currentBubble) {
              const parsed = new DOMParser().parseFromString(addData.sections['cart-icon-bubble'], 'text/html');
              const nextBubble = parsed.querySelector('#shopify-section-cart-icon-bubble');
              if (nextBubble) currentBubble.replaceWith(nextBubble);
            }
          }

          document.dispatchEvent(new CustomEvent('pbx:pack-added', {
            detail: { items, totalQuantity: state.totalQty, discount: currentTier?.discount || 0 }
          }));

          this.setStatus('Pack agregado correctamente.');
          this.button.textContent = '¡Agregado!';

          if (this.afterAdd === 'cart') {
            window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
            return;
          }

          if (this.resetAfterAdd) {
            this.cards.forEach((card) => {
              card.dataset.qty = '0';
              card.classList.remove('is-selected');
              const qtyNode = card.querySelector('[data-pbx-qty]');
              if (qtyNode) qtyNode.textContent = '0';
            });
            this.update();
          }

          window.setTimeout(() => {
            this.button.textContent = originalText;
            this.update();
          }, 1400);
        } catch (error) {
          this.setStatus(error.message || 'Ocurrió un error al agregar el pack.', true);
          this.button.textContent = originalText;
          this.update();
        }
      }
    }

    const init = (scope = document) => {
      scope.querySelectorAll('[data-pbx-root]').forEach((root) => new PBXPackBuilder(root));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        this.handleIntersection = this.handleIntersection.bind(this);

        this.observer = new IntersectionObserver(
          this.handleIntersection,
          {
            rootMargin: '0px 0px 250px 0px'
          }
        );

        this.observer.observe(this);
      }

      handleIntersection(entries) {
        if (!entries[0].isIntersecting) return;

        this.observer.unobserve(this);
        this.loadRecommendations();
      }

      loadRecommendations() {
        fetch(this.dataset.url)
          .then((response) => {
            if (!response.ok) {
              throw new Error('No se pudieron cargar las recomendaciones.');
            }

            return response.text();
          })
          .then((text) => {
            const container = document.createElement('div');
            container.innerHTML = text;

            const recommendations = container.querySelector(
              'product-recommendations'
            );

            if (
              !recommendations ||
              !recommendations.innerHTML.trim().length
            ) {
              this.hidden = true;
              return;
            }

            this.innerHTML = recommendations.innerHTML;

            /*
              Los scripts de product-card-grid llegan mediante AJAX.
              innerHTML no los ejecuta automáticamente, por eso se recrean.
              La protección global del snippet evita eventos duplicados.
            */
            this.querySelectorAll('script').forEach((oldScript) => {
              const newScript = document.createElement('script');

              Array.from(oldScript.attributes).forEach((attribute) => {
                newScript.setAttribute(
                  attribute.name,
                  attribute.value
                );
              });

              newScript.textContent = oldScript.textContent;
              oldScript.replaceWith(newScript);
            });

            document.dispatchEvent(
              new CustomEvent('bou:recommendations:loaded', {
                detail: {
                  sectionId: this.id
                }
              })
            );
          })
          .catch((error) => {
            console.error('BOU Product Recommendations:', error);
            this.hidden = true;
          });
      }
    }

    customElements.define(
      'product-recommendations',
      ProductRecommendations
    );
  }

  } catch(e) { console.error(e); }
})();
})();
